import { useCallback, useState } from 'react';

export const useTooltipHoverOrFocusVisibility = () => {
  const [hover, setHover] = useState(false);
  const [focus, setFocus] = useState(false);
  const visible = hover || focus;
  const reset = useCallback(() => {
    setHover(false);
    setFocus(false);
  }, []);
  return {
    visible,
    hoverHandlers: {
      onMouseEnter: () => setHover(true),
      onMouseLeave: () => setHover(false),
    },
    focusHandlers: {
      onFocus: () => setFocus(true),
      onBlur: () => setFocus(false),
    },
    reset,
  };
};
